import api from '@app/api/api';

import { CrfTipoProjeto } from '@app/api/crf/acronimo/projeto/crfTipoProjetoGrupo';
import { TPData } from '@app/api/crf/acronimo/projeto/crfTipoProjetoGrupo';

const controller = "crfTipoProjetoCategoria";

export const getAllCrfTipoProjetoCategorias = () => api.get<CrfTipoProjeto[]>(`${controller}`);

export const createCrfTipoProjetoCategoria = (tipoProjeto: Omit<TPData, 'codigo'>) =>
    api.post<CrfTipoProjeto>(`${controller}`, tipoProjeto);

export const updateCrfTipoProjetoCategoria = (tipoProjeto: any) => {
    const data = {
        id: tipoProjeto.id,
        nome: tipoProjeto.data.nome,
    };

    return api
        .put<boolean>(`${controller}/${data.id}`, data)
        .then(result => true)
        .catch(err => false);
};

export const deleteCrfTipoProjetoCategoria = (id: string) => api.delete(`${controller}/${id}`);